import { Injectable } from '@angular/core'
import { ActivatedRouterStateSnapshot, PageType, ProductSearchPage } from '@spartacus/core'
import { ProductFacetService } from '@spartacus/storefront'

@Injectable({
  providedIn: 'root'
})
export class EbProductFacetService extends ProductFacetService {
  /* we need to overwrite this method to check special case of range filters on search result page in
     line 23 - 29 because query params are handled differently than normal filter selection
  */
  filterForPage(state: ActivatedRouterStateSnapshot, page: ProductSearchPage): boolean {
    if (!page.currentQuery?.query?.value) {
      return false
    }
    if (state.context.type === PageType.CATEGORY_PAGE) {
      return page.currentQuery.query.value.indexOf(`allCategories:${state.context.id}`) > -1
    }

    if (
      state.context.type === PageType.CONTENT_PAGE &&
      (state.context.id === 'search' || state.context.id.includes('/search/'))
    ) {
      const index = `${state.queryParams?.query}`.indexOf(':')
      return (
        page.currentQuery.query.value.startsWith(`${state.params?.query}:`) ||
        page.currentQuery.query.value.startsWith(`${state.queryParams?.query}`.substring(0, index))
      )
    }
    return false
  }
}
